import React, { Component } from 'react'
import { combineLatest } from 'rxjs'
import getUrl from 'front-end-core/core/url'
import { PRECEDENTS_CONTENT } from 'constants/controllers'
import connect from 'components/shared/connect'
import { requestPrecedentSections, requestPrecedents } from 'services/PrecedentsService'
import { mapResponse } from 'front-end-core/helpers/dataflow'
import ArrowLink from 'components/redesign/ArrowLink'
import FileContainer from 'redux/containers/pages/precedentsall/FileContainer'
import { useSelector } from 'react-redux'
import selectAolName from 'redux/selectors/selectAolName'

const secondToLast = (array) => array[array.length - 2]

const combineRequests = (sections, precedents) => {
  const getSection = (id) => sections.nodes[id]
  const getSectionParent = (id) => getSection(secondToLast(sections.nodes[id].path))
  const getFile = (id) => precedents.files[id]
  const displaySections = getSection(sections.root).childSections
    .reduce(
      (a, parentId) => [...a, ...getSection(parentId).childSections],
      []
    )
    .map(sectionId => ({ sectionId, files: precedents.parents[sectionId] }))
    .filter(t => !!t.files)

  return { displaySections, getFile, getSection, getSectionParent }
}

@connect(({ aol }) =>
  combineLatest(
    [requestPrecedentSections(aol),
      requestPrecedents(aol)],
    mapResponse(combineRequests)
  )
)
class Main extends Component {
  render () {
    return <Sections {...this.props} />
  }
}

const Sections = ({ view, displaySections, flavour, ...props }) => (
  <div className='bg-ghost-grey'>
    <div className='layout-width-constraint'>
      <div className='bg-white mb12 bb b--precedents-blue'>
        <div className='b f3 ml6 pt8 pb6'> All Precedents </div>

        <ul className='list-reset ml0 mv0 pa0'>
          {displaySections.map((section) => <Section key={section.sectionId} view={view} {...section} {...props} />)}
        </ul>

      </div>
    </div>
  </div>
)

const Section = ({ sectionId, getSection, getSectionParent, ...props }) => (
  <li>
    <SectionTitle sectionId={sectionId} getSection={getSection} getSectionParent={getSectionParent} />
    <Files sectionId={sectionId} {...props} />
  </li>
)

const SectionTitle = ({ sectionId, getSection, getSectionParent }) => (
  <div className='bg-precedents-blue-exp pv6'>
    <div className=' white b ml6'>
      {getSectionParent(sectionId).title} {'>'} {getSection(sectionId).title}
    </div>
  </div>
)

const Files = ({ sectionId, files, view, getFile }) => {
  const sortedFiles = files.map((fileId) => getFile(fileId)).sort((a, b) => a.position - b.position)

  return (
    <ul className='file-list list-reset pa0'>
      {sortedFiles.map((file, index) => (
        <FileContainer
          {...{ sectionId, file, view }}
          key={file.id}
          isLast={index === sortedFiles.length - 1}
        />
      ))}
    </ul>
  )
}

export const BackToMainMenuLink = ({ view }) => {
  const aol = useSelector(selectAolName)

  return (
    <ArrowLink
      backArrow
      text='Back to precedent menu'
      textCx='mb4'
      url={getUrl(PRECEDENTS_CONTENT, { aol, view })}
    />
  )
}

export default Main
